/**
 * Error categories for Approval Odds feature
 * These categories help with monitoring and tracking specific issues in Datadog
 */

export enum ApprovalOddsErrorCategory {
  FETCH_ERROR = 'approval_odds_fetch_error',
  INVALID_VALUE = 'approval_odds_invalid_value',
  CREDIT_SCORE_PROCESSING = 'approval_odds_credit_score_processing',
  CONTEXT_ERROR = 'approval_odds_context_error',
}

export enum IdentityErrorCategory {
  FETCH_ERROR = 'identity_fetch_error',
}

export const AFFECTED_FEATURES = {
  APPROVAL_ODDS: 'approval_odds',
  CREDIT_SCORE: 'credit_score',
};
